<template>
  <div class="sp-sidebar" :class="{ 'sp-sidebar--open': sidebarMenuVisible }">
    <div @click="toggleSidebarMenu" class="sp-sidebar-trigger">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <ul
      class="sp-sidebar-menu__list"
      :class="{ 'sp-sidebar-menu__list--open': sidebarMenuVisible }"
    >
      <li v-for="link in links" :key="link.id" class="sp-sidebar-menu__item">
        <a class="sp-sidebar-menu__link" :href="link.url">
          {{ link.title }}
          <span class="sp-sidebar-menu__chevron"></span
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "SPSidebarMenu",
  props: {
    links: Array,
  },
  computed: { ...mapFields(["sidebarMenuVisible"]) },
  components: {},
  methods: {
    toggleSidebarMenu() {
      this.sidebarMenuVisible = !this.sidebarMenuVisible;
    },
  },
};
</script>
